import { BillingPlanFeature, useEnabledFeature } from 'resources/Organization/Features';

export const useShouldDisplayCustomers = () => {
  return useEnabledFeature(BillingPlanFeature.FEATURE_CUSTOMERS);
};

export const useShouldDisplayMyMoney = () => {
  return useEnabledFeature(BillingPlanFeature.FEATURE_ONLINE_PAYMENTS);
};

export const useShouldDisplayJobs = () => {
  return useEnabledFeature(BillingPlanFeature.FEATURE_INVOICES_LITE);
};
